/**
 * @(#)2019/9/6.
 * tag组件
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import Basics from "../Basics";
import React, { Component } from "react";
import { Tag as AntdTag, Tooltip } from "antd";
import { get, mapping, cloneDeep } from "../../../utils";
import { YxComponent, Connection } from "../../YxComponent";
import { isArray, isObject, isFunction, isString, set, omit } from "lodash";

/*
  * YxTag
  当children为数组的时候，所有的参数都支持函数， 如果数组项是字符串，则直接显示字符串， 如果数组项是对象，则使用函数来定义参数值，当前项会被当做函数形参
  注意，如果数组项为对象， 必须包含children字段，或在参数中指定取值函数  children(data)=>{return data.xxx}
  styleParam:(data)=>{
    return data.type
  }
  * @param children {ReactNode} 子节点
  * @return {ReactNode}
 * */
export const defaultProps = function () {
  return {
    children: "",
    styleParam: {
      type: "default", //类型 default，notdelete
      size: "default", //尺寸
    },
    tooltipParam: {
      //气泡组件的参数
      isTooltip: true, //是否启用气泡
    },
  };
};
@Connection(defaultProps)
class Tag extends YxComponent {
  getValue = (item) => {
    const value = get(item, ["value", "children"], "");
    if (value instanceof Function()) {
      return value(item, this.props);
    } else if (isObject(value)) {
      return get(value, ["value", "text"], "");
    }
    return value;
  };

  getTitle = (item) => {
    let title = get(item, ["tooltipParam.title", "children"]);
    if (title instanceof Function) {
      return title(item, this.props);
    } else if (isObject(title)) {
      return get(title, ["value", "text"], "");
    }
    return title;
  };

  //循环产生tag
  eachTag(tmpProps) {
    const props = { ...tmpProps };
    let tooltipParam = get(props, "tooltipParam", false);
    let classParam = {
      yx_yxText_tag_: "styleParam.type",
      yx_yxText_tag_size_: "styleParam.size",
    };
    props.className = this.styleParamClassName(props, classParam);
    let title = this.getTitle(props);
    let setTagProps = omit(props, ["styleParam", "tooltipParam"]);
    if (get(props, "tooltipParam.isTooltip", false) === true) {
      return (
        <Tooltip key={props.key} {...tooltipParam} title={title || ""}>
          <AntdTag {...setTagProps}>{this.getValue(props)}</AntdTag>
        </Tooltip>
      );
    } else {
      return (
        <AntdTag key={props.key} {...setTagProps}>
          {this.getValue(props)}
        </AntdTag>
      );
    }
  }

  propductionHtml(tmpProps) {
    let value = get(tmpProps, ["value", "children"]);
    let html = [];
    let objFunction = (obj, item) => {
      for (let i in obj) {
        if (isFunction(obj[i])) {
          set(obj, i, obj[i](item));
        } else {
          if (isObject(obj[i])) {
            objFunction(obj[i], item);
          }
        }
      }
      return obj;
    };
    if (isArray(value)) {
      delete tmpProps.value;
      delete tmpProps.data;
      delete tmpProps.allParam;
      value.map((item, index) => {
        let itemProps = cloneDeep(tmpProps);
        //为每一项添加key, 如果外部没有提供
        itemProps.key = item.key ? item.key : index;
        if (isObject(item)) {
          itemProps = objFunction(itemProps, item);
          !isString(get(itemProps, "children"))
            ? (itemProps.children = get(item, "children", item))
            : "";
          html.push(this.eachTag(itemProps));
        } else {
          itemProps.children = item;
          html.push(this.eachTag(itemProps));
        }
      });
    } else {
      if (isFunction(get(tmpProps, "children"))) {
        tmpProps.children = value;
      }
      html = this.eachTag(tmpProps);
    }

    return html;
  }

  render() {
    let tmpProps = { ...this.props };
    return (
      <div className="yx_yxText_tag yx_text">
        {this.propductionHtml(tmpProps)}
      </div>
    );
  }
}

export default Tag;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Tag/tag.js